import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Message.css';

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [filter, setFilter] = useState(null); // null = all, 0 = unviewed, 1 = viewed

  const fetchContacts = async () => {
    try {
      let url = 'https://weynibirhan.com.et/Message.php';
      if (filter !== null) url += `?viewed=${filter}`;
      const response = await axios.get(url);
      if (response.data.status === 'success') {
        setContacts(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch contacts.');
    }
  };

  const markAsViewed = async (id) => {
    await axios.put(`https://weynibirhan.com.et/contact.php?id=${id}`);
    fetchContacts();
  };

  const deleteMessage = async (id) => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      await axios.delete(`https://weynibirhan.com.et/contact.php?id=${id}`);
      fetchContacts();
    }
  };

  useEffect(() => {
    fetchContacts();
  }, [filter]);

  return (
    <div className="contact-list-container">
      <h2>Admin Contact Panel</h2>

      <div className="filter-buttons">
        <button onClick={() => setFilter(null)}>All</button>
        <button onClick={() => setFilter(0)}>Not Viewed</button>
        <button onClick={() => setFilter(1)}>Viewed</button>
      </div>

      <div className="table-responsive">
        <table className="contact-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Subject</th>
              <th>Message</th>
              <th>Date</th>
              <th>Viewed</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c, index) => (
              <tr key={c.id} className={c.viewed ? 'viewed-row' : ''}>
                <td>{index + 1}</td>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.phone}</td>
                <td>{c.subject}</td>
                <td>{c.message}</td>
                <td>{new Date(c.created_at).toLocaleString()}</td>
                <td>{c.viewed ? 'Yes' : 'No'}</td>
                <td>
                  {!c.viewed && (
                    <button onClick={() => markAsViewed(c.id)} className="action-btn">Mark as Viewed</button>
                  )}
                  <button onClick={() => deleteMessage(c.id)} className="delete-btn">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactList;
